<template>
    <div>
        <div class="hero-wrap">
            <div class="hero-mask opacity-7 bg-primary-dark"></div>
            <div class="hero-bg hero-bg-scroll" style="background-image: url('/images/business/payments-bills.webp');"></div>
            <div class="hero-content mx-auto w-100 h-100 d-flex flex-column">
                <div class="container py-5 mt-4">
                    <div class="row flex-row-reverse justify-content-center">
                        <div class="col-md-8 text-center">
                            <h2 class="text-9 text-white font-weight-bolder mb-3">
                                Corporate Bill Payments
                            </h2>
                            <p class="text-3 text-white-50 mb-4">
                                Buy prepaid electricity, airtime and data bundles for multiple accounts in one go!
                            </p>
                            <div class="my-5">
                                <template v-if="user.email">
                                    <can permission="input-transactions">
                                        <router-link class="btn btn-light btn-block d-lg-inline mb-2 mr-2" to="/business/transact">
                                            <i class="fas fa-upload ml-2"></i>
                                            Bill Payments
                                        </router-link>
                                    </can>
                                    <router-link class="btn btn-light btn-block d-lg-inline mb-2 mr-2" to="/business/dashboard">
                                        <i class="fas fa-chart-bar ml-2"></i>
                                        Dashboard
                                    </router-link>
                                    <router-link class="btn btn-light btn-block d-lg-inline mb-2 mr-2" to="/business/transactions">
                                        <i class="fas fa-history ml-2"></i>
                                        Transaction history
                                    </router-link>
                                </template>
                                <template v-else>
                                    <a class="btn btn-light btn-sm" href="/business/register">
                                        <i class="fas fa-plus-circle"></i>
                                        Sign Up
                                    </a>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section class="section py-5 bg-white">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 mb-5 p-lg-5">
                        <h2 class="text-7 font-weight-bold mb-5 text-left">
                            Improve Your Organization’s Productivity And Meet Business Obligations.
                        </h2>
                        <div class="text-3 text-justify">
                            <p>
                                In today's competitive market, maintaining consistent business operations is crucial. Any disruption in company processes and procedures can lead to lost orders and revenue. To keep your business running smoothly, it's essential to meet your payment & administration obligations promptly. However, as your company grows, it becomes challenging for your finance department to manage these payments effectively. At Magetsi, we understand the challenges faced by organizations in managing bulk transactions. We've developed a revolutionary corporate bill platform to streamline your payment processes and empower your business to thrive.

                            </p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-4">
                        <div class="sidebar-popup p-5" style="padding: 20px; background-color: #fff; border-radius: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); z-index: 1000;">
                            <div class="row">
                                <div class="col-8">
                                    <h1 class="text-large font-weight-bold" style="color: #FFCA33;">75%</h1>
                                </div>
                            </div>
                            <p class="text-dark font-weight-bold">
                                Amplify your team’s productivity by 75% with our bulk payment tool.
                            </p>
                            <p class="text-muted">
                                Turn a 2-hour task into 10 minutes. Want to know how? We can help <span>👇</span>
                            </p>
                            <a class="btn btn-primary btn-block mb-2" href='/business/register'>Sign Up Now</a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-5 position-relative p-lg-5">
                        <div class="position-relative">
                            <img class="rounded-lg shadow-lg large-img mb-4" src="/images/corporateimg.jpg" alt="Magetsi Home">
                        </div>
                    </div>
                    <div class="col-lg-7 p-lg-5">
                        <h5 class="text-5 font-weight-bold mt-4 mb-2">Sit Back, Let Magetsi Simplify Your Bulk Transactions</h5>
                        <div class="text-3 text-justify">
                            <p>Throw manual payment processes out of the way and pick up efficiency.</p>
                            <p>Our platform allows you and your team to easily make bulk payments, saving time and reducing the risk of errors.</p>
                        </div>
                        <h5 class="text-5 font-weight-bold mt-4 mb-2">Key Features:</h5>
                        <div class="text-3 text-justify">
                            <p><strong>Bulk Airtime Topup:</strong> Keep your team connected, and clients informed with instant airtime recharge for the entire office.</p>
                            <p><strong>Bulk Bundles Topup:</strong> Stay connected with ease through each employee’s connectivity.</p>
                            <p><strong>Bulk ZESA Tokens Purchase:</strong> Ensure uninterrupted power supply for all your different business locations with bulk purchases of ZESA tokens.</p>
                        </div>
                        <div class="mt-4">
                            <a href="/business/register" class="btn btn-primary btn-lg text-white">Sign Up</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section py-5 bg-light-4">
            <div class="container">
                <h2 class="text-center text-8 font-weight-bold mb-4 py-5">What are the Benefits of Bulk Payments?</h2>
                <div class="row mb-4">
                    <div class="col-md-4">
                        <div class="benefit-box text-left larger-font">
                            <strong>Saves Overall Resources and Time:</strong>
                            <p>Manually checking invoices and making payments can be labor-intensive. Automating this process with Magetsi’s bulk payment system reduces the time and resources needed for payments.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="benefit-box text-left larger-font">
                            <strong>Secure and Quick Transactions:</strong>
                            <p>Our corporate bills payment is backed by firewalls minimizing the risk of fraud or delay. Built-in security measures provide extra protection before payment is released.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="benefit-box text-left larger-font">
                            <strong>Scalable with Business Growth:</strong>
                            <p>A bulk payment solution is scalable and adaptable, growing to meet your changing business needs as your business expands.</p>
                        </div>
                    </div>
                </div>


                <div class="row justify-content-center">
                    <div class="col-md-4">
                        <div class="benefit-box text-left larger-font">
                            <strong>Quick Turnover on ROI:</strong>
                            <p>Implementing Magetsi’s bulk payment solution increases productivity by freeing finance teams from repetitive tasks, leading to faster ROI and significant savings.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="benefit-box text-left larger-font">
                            <strong>Supports Globalization:</strong>
                            <p>Our bulk payment platform allows you to top-up electricity, airtime, and bundles instantly from anywhere, making it ideal for global teams.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--Section: Why Switch to Our Corporate Bills Platform-->
        <section class="corporate-bills-platform py-5">
            <div class="container">
                <h3 class="text-center text-8 font-weight-bold mb-4 py-5">Why Switch to Our Corporate Bills Platform?</h3>

                <div class="row text-center">
                    <!-- Efficiency -->
                    <div class="col-md-3">
                        <div class="icon-box mb-3">
                            <svg class="w-[37px] h-[37px] text-red-500 dark:text-red-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="red" viewBox="0 0 24 24">
                                <path fill-rule="evenodd" d="M9 15a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm3.845-1.855a2.4 2.4 0 0 1 1.2-1.226 1 1 0 0 1 1.992-.026c.426.15.809.408 1.111.749a1 1 0 1 1-1.496 1.327.682.682 0 0 0-.36-.213.997.997 0 0 1-.113-.032.4.4 0 0 0-.394.074.93.93 0 0 0 .455.254 2.914 2.914 0 0 1 1.504.9c.373.433.669 1.092.464 1.823a.996.996 0 0 1-.046.129c-.226.519-.627.94-1.132 1.192a1 1 0 0 1-1.956.093 2.68 2.68 0 0 1-1.227-.798 1 1 0 1 1 1.506-1.315.682.682 0 0 0 .363.216c.038.009.075.02.111.032a.4.4 0 0 0 .395-.074.93.93 0 0 0-.455-.254 2.91 2.91 0 0 1-1.503-.9c-.375-.433-.666-1.089-.466-1.817a.994.994 0 0 1 .047-.134Zm1.884.573.003.008c-.003-.005-.003-.008-.003-.008Zm.55 2.613s-.002-.002-.003-.007a.032.032 0 0 1 .003.007ZM4 14a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm3-2a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm6.5-8a1 1 0 0 1 1-1H18a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-.796l-2.341 2.049a1 1 0 0 1-1.24.06l-2.894-2.066L6.614 9.29a1 1 0 1 1-1.228-1.578l4.5-3.5a1 1 0 0 1 1.195-.025l2.856 2.04L15.34 5h-.84a1 1 0 0 1-1-1Z" clip-rule="evenodd"/>
                            </svg>
                        </div>
                        <h5 class="font-weight-bold">Efficiency</h5>
                        <p>Automate repetitive tasks and reduce manual effort.</p>
                    </div>

                    <!-- Convenience -->
                    <div class="col-md-3">
                        <div class="icon-box mb-3">
                            <svg class="w-[37px] h-[37px] text-blue-500 dark:text-blue-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="blue" viewBox="0 0 24 24">
                                <path fill-rule="evenodd" d="M18 14a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z" clip-rule="evenodd"/>
                                <path fill-rule="evenodd" d="M15.026 21.534A9.994 9.994 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2c2.51 0 4.802.924 6.558 2.45l-7.635 7.636L7.707 8.87a1 1 0 0 0-1.414 1.414l3.923 3.923a1 1 0 0 0 1.414 0l8.3-8.3A9.956 9.956 0 0 1 22 12a9.994 9.994 0 0 1-.466 3.026A2.49 2.49 0 0 0 20 14.5h-.5V14a2.5 2.5 0 0 0-5 0v.5H14a2.5 2.5 0 0 0 0 5h.5v.5c0 .578.196 1.11.526 1.534Z" clip-rule="evenodd"/>
                            </svg>


                        </div>
                        <h5 class="font-weight-bold">Convenience</h5>
                        <p>Simplify payment processes with just a few clicks.</p>
                    </div>

                    <!-- Control -->
                    <div class="col-md-3">
                        <div class="icon-box mb-3">
                            <svg class="w-[37px] h-[37px] text-orange-500 dark:text-orange-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="orange" viewBox="0 0 24 24">
                                <path fill-rule="evenodd" d="M12 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2.952.462c-.483.19-.868.432-1.19.71-.363.315-.638.677-.831.93l-.106.14c-.21.268-.36.418-.574.527C6.125 6.883 5.74 7 5 7a1 1 0 0 0 0 2c.364 0 .696-.022 1-.067v.41l-1.864 4.2a1.774 1.774 0 0 0 .821 2.255c.255.133.538.202.825.202h2.436a1.786 1.786 0 0 0 1.768-1.558 1.774 1.774 0 0 0-.122-.899L8 9.343V8.028c.2-.188.36-.38.495-.553.062-.079.118-.15.168-.217.185-.24.311-.406.503-.571a1.89 1.89 0 0 1 .24-.177A3.01 3.01 0 0 0 11 7.829V20H5.5a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2H13V7.83a3.01 3.01 0 0 0 1.63-1.387c.206.091.373.19.514.29.31.219.532.465.811.78l.025.027.02.023v1.78l-1.864 4.2a1.774 1.774 0 0 0 .821 2.255c.255.133.538.202.825.202h2.436a1.785 1.785 0 0 0 1.768-1.558 1.773 1.773 0 0 0-.122-.899L18 9.343v-.452c.302.072.633.109 1 .109a1 1 0 1 0 0-2c-.48 0-.731-.098-.899-.2-.2-.12-.363-.293-.651-.617l-.024-.026c-.267-.3-.622-.7-1.127-1.057a5.152 5.152 0 0 0-1.355-.678 3.001 3.001 0 0 0-5.896.04Z" clip-rule="evenodd"/>
                            </svg>


                        </div>
                        <h5 class="font-weight-bold">Control</h5>
                        <p>Centralized platform for better oversight and management.</p>
                    </div>

                    <!-- Reliability -->
                    <div class="col-md-3">
                        <div class="icon-box mb-3">
                            <svg class="w-[37px] h-[37px] text-purple-500 dark:text-purple-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="purple" viewBox="0 0 24 24">
                                <path fill-rule="evenodd" d="M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4H6Zm7.25-2.095c.478-.86.75-1.85.75-2.905a5.973 5.973 0 0 0-.75-2.906 4 4 0 1 1 0 5.811ZM15.466 20c.34-.588.535-1.271.535-2v-1a5.978 5.978 0 0 0-1.528-4H18a4 4 0 0 1 4 4v1a2 2 0 0 1-2 2h-4.535Z" clip-rule="evenodd"/>
                            </svg>

                        </div>
                        <h5 class="font-weight-bold">Reliability</h5>
                        <p>Secure and reliable transactions for peace of mind.</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Call to Action Section -->
        <section class="cta-section py-5 text-center bg-light-4">
            <div class="container">
                <h4 class="font-weight-bold text-primary mb-3 text-7">Ready To Get Started?</h4>
                <p class="text-dark mb-4">
                    Be a part of a game-changing solution and increase your team’s productivity by 85%.
                </p>

                <h5 class="font-weight-bold mb-4">Start In 3 Simple Steps:</h5>

                <!-- Steps -->
                <div class="row justify-content-center">
                    <div class="col-md-4 mb-3">
                        <div class="step-box">
                            <span class="step-number text-white bg-primary d-inline-block mb-2">1</span>
                            <p class="text-dark mb-0">
                                <a href="https://outlook.office365.com/owa/calendar/MagetsiDemo@magetsi.co.zw/bookings/" class="text-primary font-weight-bold">Book A Demo</a>
                            </p>
                        </div>
                    </div>

                    <div class="col-md-4 mb-3">
                        <div class="step-box">
                            <span class="step-number text-white bg-primary d-inline-block mb-2">2</span>
                            <p class="text-dark font-weight-bold mb-0">Sign Up & Get Training</p>
                        </div>
                    </div>

                    <div class="col-md-4 mb-3">
                        <div class="step-box">
                            <span class="step-number text-white bg-primary d-inline-block mb-2">3</span>
                            <p class="text-dark font-weight-bold mb-0">Start Transaction</p>
                        </div>
                    </div>
                </div>
                <!-- Call to Action Button -->
                <a href="/business/register" class="btn btn-primary btn-lg text-white mt-4 px-5">Sign Up For Free</a>
            </div>
        </section>

        <!-- Partners Section -->


    </div>
</template>

<script>
import Can from "../core/can";

export default {
    name: "business",
    components: {Can, WelcomeInfo: () => import("../shared/welcome-info")},
    data: function () {
        return {
            user: window.user
        }
    },
}
</script>
<style>

.text-large{
    font-size: 120px;
}

.large-img {
    width: 400px;
    height: auto;


}
.larger-font {
    font-size: 15px;

}

.step-number {
    width: 60px;
    height: 60px;
    line-height: 60px;
    font-size: 24px;
    text-align: center;
    padding: 0;
    border-radius: 50%;
}

.large-font {
    font-size: 50px;
}
</style>
